/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { ga_push, vPush } from '../../../../services/analytics';
import { SendLead } from '../../../../services/fetch';
import { Environment } from '../../../../services/urls';
import { AppContext } from '../../../../stores/application.store'
import "./Question.scss";
interface Props {
    questionIndex: number
}

const Question = ({ questionIndex }: Props) => {
    const [selected, setSelected] = useState(-1);
    const { quizData, quizAnswers, user, setPageView, setQuestionIndex, setQuizAnswers, quizTime } = useContext(AppContext)!;

    const loadGoogleRecaptcha = () => {
        if (Environment() !== "local") {
            (() => {
                if (window.document.getElementById("GoogleRecap")) return;

                var script = document.createElement("script");
                script.type = "text/javascript";
                script.id = "GoogleRecap";
                script.async = true;
                script.src = "https://www.google.com/recaptcha/api.js";

                document.getElementsByTagName("head")[0].appendChild(script);
            })();
        }
    };

    useEffect(() => {
        if (selected !== -1) {
            setAnswer(quizData!.Questions[questionIndex].Id, selected);
        }
        loadGoogleRecaptcha();
        (window as any).sendFormViaCaptcha = sendUserLeadWithCaptcha;
    }, [selected])


    const sendUserLeadWithCaptcha = () => {

        if (Environment() !== "local") {
            (window as any).grecaptcha.reset()
        }
        if (questionIndex + 1 === quizData?.Questions.length) {
            goNext();
        }
    }
    //Goes to the next question
    const goNext = () => {
        if (selected === -1) {
            alert("נדרש לבחור תשובה");
            return;
        }

        if (questionIndex + 1 === quizData?.Questions.length) {
            let seconds = (new Date().getTime() - quizTime!.getTime()) / 1000;
            seconds = Math.abs(seconds);
            seconds = Math.floor(seconds);

            let answers = quizAnswers.map(x => x.AnswerId);
            SendLead({ ...user, Questions: answers, QuizTime: seconds });
            vPush("thank-you", "חידון פיפה - תודה על ההרשמה")
            ga_push("ga_events", "FIFA", "Quiz", "Finish Quiz");
            setPageView("thank-you")

        } else {
            vPush(`question-${questionIndex + 2}`, `חידון פיפה - ${quizData?.Questions[questionIndex + 1].Text}`)
            setQuestionIndex(questionIndex + 1);
        }
    }

    //sets the selected answer
    const setAnswer = (questionId: number, answerId: number) => {
        if (quizAnswers.find((question) => question.QuestionId === questionId)) {
            let newAnswers = quizAnswers;
            let index = quizAnswers.findIndex((x) => x.QuestionId === questionId);
            newAnswers.splice(index, 1);
            setQuizAnswers(newAnswers)
        }
        setQuizAnswers([
            ...quizAnswers,
            { QuestionId: questionId, AnswerId: answerId }
        ]);
    }

    return (
        <div className="question">
            <div className="image mobile-only"></div>
            <div className="question-title">
                <h3 className="question-index">{questionIndex + 1}.</h3>
                <h4 className="question-text">{quizData?.Questions[questionIndex].Text}</h4>
            </div>
            <div className="question-answers">
                {quizData?.Questions[questionIndex].Answers.map(
                    (answer, key) => {
                        return (
                            <div className="answer" key={key}>
                                <input
                                    type="radio"
                                    name={`question-${questionIndex}`}
                                    id={`answer-${questionIndex}-${key}`}
                                    checked={selected === answer.Id}
                                    onChange={(e) => setSelected(answer.Id)}
                                ></input>
                                <label htmlFor={`answer-${questionIndex}-${key}`}>
                                    {answer.Text}
                                </label>
                            </div>
                        )
                    }
                )}
            </div>
            <div className="arrows">

                <div className="right-container">
                </div>
                <div className="numbers">
                    <span className="current">{questionIndex + 1}</span>
                    <span className="slash">/</span>
                    <span className="total">{quizData?.Questions.length}</span>
                </div>

                <div className="left-container">
                    <div className="next" onClick={goNext}>{(questionIndex + 1 === quizData?.Questions.length)
                        &&
                        <div
                            className="g-recaptcha"
                            data-callback="sendFormViaCaptcha"
                            data-size="invisible"
                            data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
                        ></div>
                    }</div>
                </div>
            </div>
        </div>
    )
}

export default Question
